import styled from 'styled-components';
import PeriodField from '../../../UI/Field/Period/PeriodField';

export const FaseAtualPeriod = styled(PeriodField)`
  width: 100%;
  margin-top: 8px;
  margin-right: 8px;
`;
